import { createClient } from '@supabase/supabase-js'

// Supabase Configuration
// Get these from: Supabase Dashboard → Settings → API
const SUPABASE_URL = 'https://uwhnilnrxdifrvtrtocl.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV3aG5pbG5yeGRpZnJ2dHJ0b2NsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU3Nzg2MjksImV4cCI6MjA4MTM1NDYyOX0.agJ1FUkhYTNv_6bEvG1azCWgoG-tIgBG_thhuBPiJys'

// Create Supabase client
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

// Universal helper function to save survey response to any table
export async function saveSurveyResponse(
  tableName: string,
  data: {
    sessionId: string
    surveyData: any
    isComplete: boolean
    completedSections: string
    currentSection: string
    metadata?: any
  },
) {
  try {
    const { data: result, error } = await supabase
      .from(tableName)
      .upsert(
        {
          session_id: data.sessionId,
          is_complete: data.isComplete,
          completed_sections: data.completedSections,
          current_section: data.currentSection,
          email: data.surveyData.email,
          survey_data: data.surveyData,
          metadata: data.metadata,
          updated_at: new Date().toISOString(),
        },
        {
          onConflict: 'session_id',
        },
      )
      .select()

    if (error) {
      console.error(`❌ Supabase error (${tableName}):`, error)
      // Don't throw - fail gracefully since Google Sheets is primary
      return { success: false, error }
    }

    console.log(`✅ Saved to Supabase (${tableName})`)
    return { success: true, data: result }
  } catch (error) {
    console.error(`❌ Supabase error (${tableName}):`, error)
    // Don't throw - fail gracefully since Google Sheets is primary
    return { success: false, error }
  }
}
